module.exports = __webpack_public_path__ + "c96a69d387cce87144365b970f7e8e9c.svg";